<template>
  <div class="add-to-box-btn" :class="value && isAddonFlower?'red darken-3':''">
      <div style="width: 100%" @click="increase" v-if="!value">{{actionText}}</div>
      <div style="width: 100%" class=" white--text" @click="reduce" v-else-if="value && isAddonFlower">Remove</div>
      <div v-else class="d-flex justify-space-around counter-wrapper align-center">
          <v-btn @click="reduce" class="xx-small" elevation="0" color="primary" fab x-small>
              <v-icon>mdi-minus</v-icon>
          </v-btn>
            <input readonly :value="value" @change="updateInput" type="text">
            <v-btn @click="increase" class="xx-small" elevation="0" color="primary" fab x-small>
              <v-icon>mdi-plus</v-icon>
          </v-btn>
      </div>
    </div>
</template>

<script>
export default {
    name: 'hb-bab-product-card',
    props:{
        actionText: {
            type: String,
            default: 'Add to box'
        },
        value: Number,
        hasVariants: Boolean,
        isAddonFlower: Boolean
    },
    methods:{
        increase(){
            if(this.isAddonFlower){
                this.$emit('showProductDialog');
                return;
            }

            if(!this.hasVariants)
                this.$emit('input', this.value + 1);
            else
                this.$emit('showProductDialog');
        },
        reduce(){
            console.log(this.value)
            if(this.value == 0) return;
            this.$emit('input', this.value - 1);
        },
        updateInput(value){
            this.$emit('input',value)
        }
    },
};
</script>

<style scoped>
.add-to-box-btn {
  position: absolute;
  top: -16%;
  background: white;
  text-transform: uppercase;
  padding: 0.5rem 0;
  left: 50%;
  transform: translateX(-50%);
  border: 1px solid #eaecf4;
  box-sizing: border-box;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.09);
  border-radius: 5rem;
  font-size: 0.8rem;
  font-weight: 400;
  color: #666;
    width: 10rem;
    text-align: center;
    line-height: 2.1;
}

input{
    border: none;
    width: 2rem;
    padding: 0;
    text-align: center;
    font-weight: 500;
    font-size: 1.5rem !important;
    color: black !important;
    line-height: 1 !important;
}

button.xx-small{
    height: 25px !important;
    width: 25px !important;
}
</style>